"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTimeout = _interopRequireDefault(require("react-timeout"));

var _styles = require("./styles");

exports.MenuList = _styles.MenuList;
exports.MenuListItem = _styles.MenuListItem;

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const OPEN = 'OPEN';
const CLOSED = 'CLOSED';
const OPEN_ANIMATING_IN = 'OPEN_ANIMATING_IN';
const OPEN_ANIMATING_OUT = 'OPEN_ANIMATING_OUT';

const DropdownMenu = ({
  placeholder,
  options,
  onChange,
  disabled,
  setTimeout,
  ...otherProps
}) => {
  const [dropdownState, setDropdownState] = (0, _react.useState)(CLOSED);
  const menuTriggerRef = (0, _react.useRef)();
  const node = (0, _react.useRef)();
  const toggleOpen = (0, _react.useCallback)(() => {
    if (dropdownState === OPEN || dropdownState === CLOSED) {
      setDropdownState(open => open === OPEN ? OPEN_ANIMATING_OUT : OPEN_ANIMATING_IN);
    }
  }, [dropdownState, setDropdownState]);

  const closeDropdown = () => {
    setDropdownState(dropdownState => dropdownState === OPEN ? OPEN_ANIMATING_OUT : dropdownState);
  };

  const getAnimationClass = () => {
    if (dropdownState === OPEN_ANIMATING_IN) return 'slideIn';
    if (dropdownState === OPEN_ANIMATING_OUT) return 'slideOut';
    return null;
  };

  (0, _react.useEffect)(() => {
    if (dropdownState === OPEN_ANIMATING_OUT) {
      setTimeout(() => {
        setDropdownState(CLOSED);
      }, 250);
    }

    if (dropdownState === OPEN_ANIMATING_IN) {
      setTimeout(() => {
        setDropdownState(OPEN);
      }, 250);
    }
  }, [dropdownState, setDropdownState]);

  const handleClick = e => {
    if (node && node.current.contains(e.target)) {
      return;
    }

    closeDropdown();
  };

  (0, _react.useEffect)(() => {
    document.addEventListener('mousedown', handleClick, false);
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
      closeDropdown();
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledDropdownMenu, {
    ref: node,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DropdownMenuButton, {
      ref: menuTriggerRef,
      type: "button",
      "aria-haspopup": "true",
      "aria-expanded": dropdownState !== CLOSED,
      disabled: disabled,
      ...otherProps,
      onClick: toggleOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonCaret, {
        open: dropdownState !== CLOSED,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          width: "10",
          height: "6",
          viewBox: "0 0 10 6",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              transform: "translate(-883 -462)",
              stroke: "currentColor",
              strokeWidth: "1.5",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
                transform: "rotate(-180 887.937 465)",
                points: "884 466.873321 887.873321 463 891.873321 467"
              })
            })
          })
        })
      }), placeholder]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DropdownMenuOverlay, {
      open: dropdownState !== CLOSED,
      className: getAnimationClass(),
      onClick: closeDropdown,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MenuList, {
        children: options.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MenuListItem, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MenuListItemButton, {
            type: "button",
            onClick: () => onChange(item.value),
            children: item.label
          })
        }, index))
      })
    })]
  });
};

DropdownMenu.propTypes = {
  placeholder: _propTypes.default.string.isRequired,
  options: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool
};
DropdownMenu.defaultProps = {
  placeholder: 'Please select...',
  options: []
};

var _default = (0, _reactTimeout.default)(DropdownMenu);

exports.default = _default;